const Rules = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">정관</h5>
        <p className="card-text">

          제1장: 총칙 <br /> <br />
          제1조 (명칭) <br />
          1. 이 조직의 명칭은 "맨체스터시티 OSC MCI"로 한다. 이후 "지사"라고 한다. <br /> <br />

          제2조 (설립목적) <br />
          1. 본 지사는 맨체스터시티 팬들의 모임이다.  <br />
          2. 본 지사의 목적은 맨체스터시티 클럽 응원 및 팬들간의 소통이다. <br /><br />

          제3조 (운영방침 다짐) <br />
          1. 본 지사는 다음의 운영방침을 준수한다. <br />
          <div class="text-t">1-1. 회원들을 어떠한 이유에서든 차별하지 않으며, 회원들 간에 평등하게 대우한다.</div>
          <div class="text-t">1-2. 권력남용과 특혜를 없애고, 모든 회원들이 동등한 기회를 누리도록 한다.</div>
          <div class="text-t">1-3. 회원이 아닌 자를 대가를 지불하여 섭외 하지 않는다.</div>
          <div class="text-t">1-4. 모두가 볼 수 있고 납득할 수 있는 운영, 관리를 한다.</div>
          <div class="text-t">1-5. 영리적인 활동을 하지 않는다.</div> <br />

          제4조 (회원 자격) <br />
          1. 본 지사의 회원 자격은 맨체스터시티 구단측에 본 지사의 가입 목적으로 의무 송금액을 송금하는 자에게 개방된다. <br />
          <div class="text-t">1-1. 맨체스터시티 구단측에 년 1회 의무 송금액을 송금해야하며, 송금하지 않을경우 해당 년도 회원자격이 박탈된다. <br /></div>
          <div class="text-t"> 1-2. 맨체스터시티 구단측에 송금해야하는 의무 송금액은 자유이며, 맨체스터시티 구단측에서 정한 최소 금액이 상을 송금해야한다. <br /></div>
          2. 회원들은 모든 조직 활동에 자발적으로 참여할 수 있으며, 회원 탈퇴를 원할 경우 언제든지 가능하다. <br />
          3. 개인적으로 부당한 이익을 취하는 등의 기만 행위를 하는자는 영구제명 및 취한 모든 부당한 이익을 다시 지사로 반납해야한다. <br />
          4. 제3조 운영방침을 어기는자, 어떠한 이유에서든 맨체스터시티 혹은 본 지사에 해를 가하는자, 사회통념상 지사의 분위기를 흐리는 자는 회원 자격이 박탈된다. <br /> <br />

          제5조 (자금 관리) <br />
          1. 본 지사는 금전 관련 모든 내역을 투명하게 공개하고 철저하게 관리한다. <br />
          2. 회비로 주류는 구입하지 않으며, 가입비는 구단 송금 금액 외에 받지 않는다. <br />
          3. 모임 회비와 기부금은 따로 관리하며 기부금은 지사내 이벤트 및 기부 활동 등에 사용한다. <br />
          4. 모임 회비, 기부금을 개인적인 용도로 사용하지 않는다.<br />
          5. 모임 회비의 경우 필요한 만큼만 측정하여 최대한 남지 않도록 노력 한다.<br /><br />
           

          제6조 (이벤트 추첨) <br />
          1. 지사에서 진행하는 이벤트 추첨은 100% 랜덤 추첨만 사용하며, 모든 회원이 공정하게 참여할 수 있도록 한다. <br />
          2. 추첨 과정과 결과는 투명하게 공개한다. <br /> <br />

          제7조 (운영진 선출과 임기) <br />
          1. 지사 운영을 위해 총무, SNS 담당 등 특정 운영진을 회원들 중에서 선출하여 임기를 명시한다. <br />
          2. 운영진은 선출 후 지정된 임기 기간 동안 활동하며, 임기 만료 시 새로운 운영진을 선출한다. <br /> <br />

          제8조 (변제) <br />
          1. 이 정관에 명시되지 않은 사항 및 기타 필요한 사항은 회원들과 협의하여 결정하며, 변경될 수 있다. <br /> <br />

          제9조 (개인정보보호) <br />
          1. 지사는 회원들의 개인정보를 철저히 보호하며, 관련법규를 준수한다. <br /> <br />

          부칙 <br />
          1. 이 정관은 지사 신설 시부터 시행한다. <br /> <br />
        </p>
      </div>
    </div>
  );
};

export default Rules;
